module.exports = __webpack_public_path__ + "static/sc-01-e2f51bac2071cdb199d32981e1cba7b4.png";